/*
 * @Author: 俊昌 junchang.zhang@wahool.com
 * @Date: 2023-03-01 15:30:51
 * @LastEditors: 俊昌 junchang.zhang@wahool.com
 * @LastEditTime: 2024-01-24 18:44:38
 * @FilePath: /flowBusinessui/src/api/live.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import request from '@/utils/request'

/**
 * 获取指定月份的列表
 * http://yapi.wahool.com/project/11/interface/api/1966
 * @param data
 * @param store
 * @returns {Promise | Promise<any>}
 */
export function getCalendarMonth(data, store) {
  return request.GET('/api/calendar/month', data, { store })
}
/**
 * 用户关联的所有店铺
 * http://yapi.wahool.com/project/11/interface/api/1937
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getStoreList(data) {
  return request.GET('/api/account/store/list', data)
}
/**
 * @description: 获取用户关联店铺
 * @param {*} data
 * @return {*}
 */
export function storesForAmazonList(data) {
  return request.GET('/supplier/amazon-account/stores-for-amazon-authorization', data)
}
/**
 * 获取指定日期详情
 * http://yapi.wahool.com/project/11/interface/api/1969
 * @param data
 * @param store
 * @returns {Promise | Promise<any>}
 */
export function getDayDetails(data, store) {
  return request.GET('/api/calendar/day', data, { store })
}
/**
 * 获取指定日期主播
 * http://yapi.wahool.com/project/11/interface/api/1972
 * @param data
 * @param store
 * @returns {Promise | Promise<any>}
 */
export function getDayInfluencer(data, store) {
  return request.GET('/api/calendar/influencer', data, { store })
}
/**
 * 获取所有主播
 * http://yapi.wahool.com/project/11/interface/api/2432
 * @param data
 * @param store
 * @returns {Promise | Promise<any>}
 */
export function allInfluencer(data, store) {
  return request.GET('/api/calendar/all-influencer', data, { store })
}
